import React from "react";
import { Link } from "react-router-dom";

import { getMain } from "../common/Navigations";
import { useSectionOpen } from "../common/useParityAccess";

const SideNavigations = ({ handleNav, currentSideNav }) => {
  const sectionOpen = useSectionOpen();
  const isCurrentTab = (tab) => {
    return tab.id === currentSideNav?.id ? "active" : "";
  };
  const visible = getMain().filter((nav) => {
    if (nav.section) return sectionOpen(nav.section);
    if (Array.isArray(nav.sections)) return nav.sections.some((id) => sectionOpen(id));
    return true;
  });

  return (
    <div className="side-navigations">
      <ul>
        {visible.map((nav, i) => (
          <Link key={i} to={nav.path} onClick={() => handleNav(nav)}>
            <li key={i} className={isCurrentTab(nav)}>
              {nav.icon}
              <span>{nav.label}</span>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default SideNavigations;
